import DashboardLayout from '../layouts/DashboardLayout'

export const reportMktMenu = {
    path: '/report',
    component: DashboardLayout,
    name: 'Report',
    // redirect: '/leader-report',
    children: [
        {
            path: 'define-facebook-page-responsible',
            name: 'FacebookPageByMarketer',
            component: () => import('../pages/report-mkt/define-facebook-page-responsible/index'),
            meta: {
                roles: ['define-master-content_read'],
                // roles: 'all',
                requiresAuth: true,
                breadcrumb: [{
                    title: 'Khai báo mã content'
                }]
            }
        },
        {
            path: 'marketing-report-by-marketer',
            name: 'MarketingReportByMarketer',
            component: () => import (/* webpackChunkName: "about" */'../pages/report-mkt/by-maketer/MarketerReport.vue'),
            meta: {
                roles: ['marketer-report_read', 'marketer-report_view_all'],
                requiresAuth: true,
                breadcrumb: [{
                title: 'Báo cáo marketing theo nhân viên'
                }]
            },
        },
        {
            path: 'marketing-report-by-content',
            name: 'MarketingReportByContent',
            component: () => import (/* webpackChunkName: "about" */'../pages/report-mkt/by-content/ContentReport.vue'),
            meta: {
                roles: ['marketing-report-by-content_read', 'marketing-report-by-content_view_all'],
                requiresAuth: true,
                breadcrumb: [{
                    title: 'Báo cáo marketing theo content'
                }]
            },
        },
        {
            path: 'contact-register',
            name: 'ContactRegisterReport',
            component: () => import (/* webpackChunkName: "about" */'../pages/report-mkt/contact-register-report/ContactRegisterReport.vue'),
            meta: {
                roles: ['contact-register_read'],
                requiresAuth: true,
                breadcrumb: [{
                    title: 'Báo cáo đăng ký theo ngày'
                }]
            }
        },
        {
            path: 'short-link',
            name: 'ShortLink',
            component: () => import (/* webpackChunkName: "about" */'../pages/report-mkt/short-link/index.vue'),
            meta: {
                roles: ['short-link_read'],
                requiresAuth: true,
                breadcrumb: [{
                    title: 'Short Link'
                }]
            }
        },
        {
            path: 'performance-mkt',
            name: 'PerformanceMkt',
            component: () => import (/* webpackChunkName: "about" */'../pages/report-mkt/performance-mkt/index.vue'),
            meta: {
                roles: ['performance-mkt_read'],
                requiresAuth: true,
                breadcrumb: [{
                    title: 'Báo cáo messenger'
                }]
            }
        },
    ]
}